export default __webpack_public_path__ + "media/images/manual/ic/04-a042114495cff714cd7a7991d1b527d2.png";